export const constantsActive = {
	YES: 'yes',
	NO: 'no'
}

export const constantsGraphql = {
	YES: 'yes',
	NO: 'no',
	YES_NO: ['yes', 'no']
}

export const tableConstants = {
	BUILDINGS: 'buildings',
	COMPANIES: 'companies',
	DEPARTMENTS: 'departments',
	FLOORS: 'floors',
	FUNCTIONS: 'functions',
	ROOMS: 'rooms',
	TABLES: 'tables',
	LUNCH_OPTIONS: 'lunchOptions',
	TEAMS: 'teams',
	TIMESLOTS: 'timeslots',
	JOBTITLES: 'jobtitles',
	TIMESLOTKINDS: 'timeslotKinds',
	TIMESLOTGROUPS: 'timeslotGroups',
	CREDIT_BUNDLES: 'creditBundles',
	//LANGUAGES: 'languages',
}
